<template>
  <FadeTransition>
    <b-alert
      v-bind="$attrs"
      v-model="isVisible"
      :class="[{ 'alert-dismissible': $props.dismissible }]"
      role="alert"
    >
      <slot v-if="!$props.dismissible"></slot>

      <template v-else>
        <template v-if="!!$props.icon || !!$slots.icon">
          <slot name="icon">
            <span class="alert-icon mr-2" data-notify="icon">
              <i :class="$props.icon"></i>
            </span>
          </slot>
        </template>

        <span class="alert-text">
          <slot></slot>
        </span>

        <slot name="dismiss-icon">
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click="() => (isVisible = false)"
          >
            <span aria-hidden="true">×</span>
          </button>
        </slot>
      </template>
    </b-alert>
  </FadeTransition>
</template>
<script>
import { defineComponent, ref } from '@vue/composition-api'
import { FadeTransition } from 'vue2-transitions'

export default defineComponent({
  name: 'BaseAlert',
  components: {
    FadeTransition
  },
  props: {
    type: {
      type: String,
      default: 'default'
    },
    dismissible: Boolean,
    icon: String
  },
  setup() {
    const isVisible = ref(true)

    return {
      isVisible
    }
  }
})
</script>
